export default __webpack_public_path__ + "static/media/logo.43f312a2.svg";